import React, { useState} from "react";
import { Navbar, Nav, Image } from "react-bootstrap";
import logo from "../assets/images/CholaCafeLogo.png";
import "../NavbarStyles.css"; // custom styles


const Header = () => {
  const [expanded, setExpanded] = useState(false);
  const [activeLink, setActiveLink] = useState("#home"); 
  const orderNowUrl = process.env.REACT_APP_ORDER_NOW_URL;
  const bookNowUrl = process.env.REACT_APP_BOOK_NOW_URL;
  
  const handleNavClick = (link) => {
    setActiveLink(link); 
    setExpanded(false); 
  };
  return (
    <Navbar expand="lg" expanded={expanded} onToggle={setExpanded} className="custom-header" sticky="top" variant="dark">
        <Navbar.Brand href="#home" className="d-flex align-items-center">
          <Image src={logo} alt="Chola Cafe" height={40} className="navbar-logo" />
          <span className="brand-text">CHOLA CAFE</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-end">
          <Nav className="ms-auto navbar-links">
            <Nav.Link href="#home" onClick={() => handleNavClick("#home")} className={`custom-nav-link ${activeLink === "#home" ? "active" : ""}`}>Home</Nav.Link>
            <Nav.Link href={orderNowUrl}  onClick={() => handleNavClick(orderNowUrl)}  className={`custom-nav-link ${activeLink === orderNowUrl ? "active" : ""}`} target="_blank" rel="noopener noreferrer">Order Now</Nav.Link>
            <Nav.Link href="#menu"  onClick={() => handleNavClick("#menu")}  className={`custom-nav-link ${activeLink === "#menu" ? "active" : ""}`}>Menu</Nav.Link>
            <Nav.Link href="#contact" onClick={() => handleNavClick("#contact")} className={`custom-nav-link ${activeLink === "#contact" ? "active" : ""}`}>Contact</Nav.Link>
            <Nav.Link href={bookNowUrl} onClick={() => handleNavClick(bookNowUrl)} className={`custom-nav-link ${activeLink === bookNowUrl ? "active" : ""}`} target="_blank" rel="noopener noreferrer">Book Now</Nav.Link>
          </Nav>
        </Navbar.Collapse>
    </Navbar>
  );
};

export default Header;
